(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["be-header"] && !Shopify.designMode) return;
  try {
    
  class BeSiteHeader extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.desktopMenus = Array.from(this.querySelectorAll('.be-desktop-category'));
      this.searchMenu = this.querySelector('.be-search');
      this.mobileMenu = this.querySelector('.be-mobile-menu');
      this.mobileCloseButton = this.querySelector('.be-mobile-menu__close');

      this.desktopMenus.forEach((menu) => {
        menu.addEventListener('toggle', this.handleToggle, { signal: this.controller.signal });
      });

      document.addEventListener('pointerdown', this.handlePointerDown, { signal: this.controller.signal });
      document.addEventListener('keydown', this.handleKeyDown, { signal: this.controller.signal });
      this.mobileCloseButton?.addEventListener('click', this.handleMobileClose, { signal: this.controller.signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    handleToggle = (event) => {
      if (!event.currentTarget.open) return;

      this.desktopMenus.forEach((menu) => {
        if (menu !== event.currentTarget) menu.open = false;
      });

      if (this.searchMenu) this.searchMenu.open = false;
    };

    handlePointerDown = (event) => {
      this.desktopMenus.forEach((menu) => {
        if (menu.open && !menu.contains(event.target)) menu.open = false;
      });

      if (this.searchMenu?.open && !this.searchMenu.contains(event.target)) {
        this.searchMenu.open = false;
      }
    };

    handleKeyDown = (event) => {
      if (event.key !== 'Escape') return;

      const openMenu = this.desktopMenus.find((menu) => menu.open);
      if (openMenu) {
        openMenu.open = false;
        openMenu.querySelector('summary')?.focus();
      }

      if (this.searchMenu?.open) {
        this.searchMenu.open = false;
        this.searchMenu.querySelector('summary')?.focus();
      }
    };

    handleMobileClose = () => {
      if (this.mobileMenu) {
        this.mobileMenu.open = false;
        this.mobileMenu.querySelector(':scope > summary')?.focus();
      }
    };
  }

  if (!customElements.get('be-site-header')) {
    customElements.define('be-site-header', BeSiteHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-main-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.be-collection-description details').forEach((details) => {
    const summary = details.querySelector(':scope > summary');
    if (summary && !summary.textContent.trim()) {
      details.open = true;
      summary.hidden = true;
    }
  });

  document.querySelectorAll('[data-be-infinite-scroll]').forEach((control) => {
    if (control.dataset.beInfiniteReady === 'true') return;
    control.dataset.beInfiniteReady = 'true';

    const section = control.closest('.be-collection');
    const grid = section?.querySelector('.be-collection-grid');
    const link = control.querySelector('[data-be-load-more]');
    const status = control.querySelector('[data-be-infinite-status]');
    if (!section || !grid || !link) return;

    let loading = false;
    let observer;

    const markComplete = () => {
      control.classList.remove('is-loading');
      control.classList.add('is-complete');
      control.removeAttribute('aria-busy');
      if (status) status.textContent = 'Tous les produits sont affichés';
      observer?.disconnect();
    };

    const loadNextPage = async () => {
      const nextUrl = control.dataset.nextUrl || link.getAttribute('href');
      if (!nextUrl || loading || control.classList.contains('is-complete')) return;

      loading = true;
      control.classList.add('is-loading');
      control.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Chargement des produits';

      try {
        const response = await fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error(`Réponse HTTP ${response.status}`);

        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const nextGrid = html.querySelector('.be-collection-grid');
        if (!nextGrid) throw new Error('Grille de produits introuvable');

        const cards = Array.from(nextGrid.children);
        if (!cards.length) {
          markComplete();
          return;
        }

        const fragment = document.createDocumentFragment();
        cards.forEach((card) => fragment.appendChild(document.importNode(card, true)));
        grid.appendChild(fragment);

        const nextControl = html.querySelector('[data-be-infinite-scroll]');
        const followingUrl = nextControl?.dataset.nextUrl || nextControl?.querySelector('[data-be-load-more]')?.getAttribute('href');

        if (followingUrl && followingUrl !== nextUrl) {
          control.dataset.nextUrl = followingUrl;
          link.setAttribute('href', followingUrl);
          control.classList.remove('is-loading');
          control.removeAttribute('aria-busy');
          if (status) status.textContent = 'Continuez à défiler pour afficher la suite';
          loading = false;
          observer?.observe(control);
        } else {
          markComplete();
        }
      } catch (error) {
        console.error('Défilement infini :', error);
        control.classList.remove('is-loading');
        control.removeAttribute('aria-busy');
        control.dataset.loadFailed = 'true';
        link.textContent = 'Voir la page suivante';
        if (status) status.textContent = 'Le chargement automatique est indisponible';
        observer?.disconnect();
        loading = false;
      }
    };

    link.addEventListener('click', (event) => {
      if (control.dataset.loadFailed === 'true') return;
      event.preventDefault();
      observer?.unobserve(control);
      loadNextPage();
    });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        (entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            observer.unobserve(control);
            loadNextPage();
          }
        },
        { rootMargin: '500px 0px', threshold: 0.01 }
      );
      observer.observe(control);
    } else if (status) {
      status.textContent = 'Utilisez le bouton pour afficher la suite';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["be-main-product"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.be-product').forEach((section) => {
    const sticky = section.querySelector('.be-sticky-buy');
    const mainButton = section.querySelector('.be-add-to-cart');

    section.querySelectorAll('[data-delivery-date]').forEach((time) => {
      const deliveryDate = new Date();
      deliveryDate.setHours(12, 0, 0, 0);
      deliveryDate.setDate(deliveryDate.getDate() + 2);
      const locale = document.documentElement.lang || 'fr-FR';
      time.dateTime = deliveryDate.toISOString().slice(0, 10);
      time.textContent = new Intl.DateTimeFormat(locale, {
        weekday: 'long',
        day: 'numeric',
        month: 'long'
      }).format(deliveryDate);
    });

    section.querySelectorAll('[data-offer-tabs]').forEach((tabList) => {
      const tabs = Array.from(tabList.querySelectorAll('[data-offer-tab]'));
      const form = tabList.closest('form');
      const panels = form ? Array.from(form.querySelectorAll('[data-offer-panel]')) : [];
      const primaryActions = form ? form.querySelector('[data-primary-purchase-actions]') : null;

      const activateTab = (tab) => {
        const value = tab.dataset.offerTab;
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', active ? 'true' : 'false');
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.offerPanel !== value;
        });
        if (primaryActions) primaryActions.hidden = value === 'mixed';
        if (value !== 'mixed' && form) {
          const quantity = form.querySelector(`[data-quantity-choice="${value}"]`);
          if (quantity) {
            quantity.checked = true;
            quantity.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      };

      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activateTab(tab));
        tab.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          const nextTab = tabs[(index + direction + tabs.length) % tabs.length];
          activateTab(nextTab);
          nextTab.focus();
        });
      });
    });

    if (sticky && mainButton) {
      const observer = new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting);
      }, { threshold: 0.15 });
      observer.observe(mainButton);
    }

    section.querySelectorAll('[data-duo-add]').forEach((button) => {
      button.addEventListener('click', async () => {
        const form = document.getElementById(button.dataset.productForm);
        const status = section.querySelector('[data-duo-status]');
        const variantField = form ? form.querySelector('[name="id"]') : null;
        if (!variantField || !button.dataset.complementaryVariant) return;

        button.disabled = true;
        if (status) status.textContent = '';

        try {
          const response = await fetch(section.dataset.cartAddJsonUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: [
                { id: Number(variantField.value), quantity: 1 },
                { id: Number(button.dataset.complementaryVariant), quantity: 1 }
              ]
            })
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(section.dataset.cartUrl);
        } catch (error) {
          if (status) status.textContent = section.dataset.buyError;
          button.disabled = false;
        }
      });
    });

    section.querySelectorAll('[data-buy-now]').forEach((button) => {
      button.addEventListener('click', async () => {
        const form = document.getElementById(button.dataset.productForm);
        if (!form) return;

        const buttons = section.querySelectorAll('[data-buy-now]');
        const status = section.querySelector('.be-buy-status');
        buttons.forEach((item) => { item.disabled = true; });
        if (status) status.textContent = '';

        try {
          const response = await fetch(section.dataset.cartAddUrl, {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form)
          });
          if (!response.ok) throw new Error('cart');
          window.location.assign(section.dataset.checkoutUrl);
        } catch (error) {
          if (status) status.textContent = section.dataset.buyError;
          buttons.forEach((item) => { item.disabled = false; });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('submit', (event) => {
    const quiz = event.target.closest('.be-article-quiz');
    if (!quiz) return;

    event.preventDefault();

    const values = [...quiz.querySelectorAll('input[type="radio"]:checked')].map((input) => input.value);
    const scores = values.reduce((result, value) => {
      result[value] = (result[value] || 0) + 1;
      return result;
    }, {});

    const ranked = Object.entries(scores).sort((left, right) => right[1] - left[1]);
    let outcome = ranked[0]?.[0] || 'versatile';

    if (ranked.length === 3 && ranked[0][1] === ranked[1][1]) {
      outcome = 'versatile';
    }

    quiz.querySelectorAll('[data-quiz-result]').forEach((result) => {
      result.hidden = result.dataset.quizResult !== outcome;
    });

    quiz.querySelector(`[data-quiz-result="${outcome}"]`)?.scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
    });
  });

  } catch(e) { console.error(e); }
})();
})();
